//模板下载接口
import request from '@/router/axios'

export function getNewsAll(params) {
	return request({
		url: `/dist/distChannel/getMarketList`,
		method: 'get',
		params,
	})
}

export function getNewsEnable(params) {
	return request({
		url: `/dist/distChannel/getMarketList`,
		method: 'get',
		params,
	})
}

export function addNews(params) {
	return request({
		url: `/dist/distChannel/market`,
		method: 'post',
		data: params,
	})
}

export function EditNews(params) {
	return request({
		url: `/dist/distChannel/market`,
		method: 'put',
		data: params,
	})
}

export function delNews(id) {
	return request({
		url: `/dist/distChannel/market/${id}`,
		method: 'delete',
	})
}

//type 1: 上升，2：下降
export function sortNews(data) {
	return request({
		url: `/dist/distChannel/marketList/sort`,
		method: 'put',
		data,
	})
}

export function getAnnouncement(params) {
	return request({
		url: `/dist/message/page`,
		method: 'get',
		params,
	})
}
export function getAnnouncementById(id) {
	return request({
		url: `/dist/message/${id}`,
		method: 'get',
	})
}

export function getAnnouncementIndex(params) {
	return request({
		url: `/dist/message/user/page`,
		method: 'get',
		params,
	})
}

export function addAnnouncement(params) {
	return request({
		url: `/dist/message`,
		method: 'post',
		data: params,
	})
}

export function editAnnouncement(params) {
	return request({
		url: `/dist/message`,
		method: 'put',
		data: params,
	})
}

export function delAnnouncement(data) {
	return request({
		url: `/dist/message`,
		method: 'delete',
		data,
	})
}

export function readAnnouncementIndex(id) {
	return request({
		url: `/dist/message/read?id=${id}`,
		method: 'post',
	})
}
